import React, { useRef, useState } from 'react'
import { Alert, Button, Col, Form, Modal, OverlayTrigger, Row, Tooltip } from 'react-bootstrap'
import { AiOutlineHome } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import { bulkGdprData, status } from './Form.data'
import loaderGif from "../../images/gif/loader.gif";
import MpaasAdminPanelApi from '../../utils/MpaasAdminPanelApi'
import {ReactComponent as ArrowLeft} from "../../images/arrow_left.svg"
import {ReactComponent as Info} from "../../images/info.svg"


const ProcessBulkGDPR = () => {

    const [error, setError] = useState("")
    const [response, setResponse] = useState({
        loading: false,
        message: "",
        data: "",
        status: ""
    })
    const [showModal, setShowModal] = useState(false);
    const formRef = useRef<HTMLFormElement | null>(null)

    const handleSubmitConfirm = () => {
        setShowModal(false)
        if(!formRef?.current) {
            return;
        }
        const formData = new FormData(formRef.current);
        const fileInput = formData.get('userId');
        const clientId = formData.get('clientId')

        if ((fileInput instanceof File) && fileInput?.name) {
            let isError = false;
            const maxSize = 200*1024;
            const allowedExtensions = ['xls', 'xlsx'];
            const fileExtension = fileInput.name?.split('.')?.pop()?.toLowerCase() ?? "";

            if (!allowedExtensions?.includes(fileExtension)) {
                setError('Only Excel files (.xls, .xlsx) are allowed.');
                isError=true
            } else if(fileInput.size > maxSize) {
                setError('File size should not exceed 200 KB');
                isError=true
            }

            if(isError) {
                setResponse({
                    loading: false,
                    message: "",
                    data: "",
                    status: ""
                })
                return;
            }
        }
        setError('');

        setResponse((prev: any) => ({
            ...prev,
            loading: true
        }))

        const uploadData = new FormData()
        if(fileInput instanceof Blob) {
            uploadData.append('file', fileInput)
        }
        MpaasAdminPanelApi.bulkDeleteGDPR(uploadData, clientId as string).then((response: any) => {
            setResponse((prev: any) => ({
                ...prev,
                loading: false,
                message: response.response,
                data: response,
                status: response.status

            }))

        }).catch(error => {
            const errorMessage = error?.response?.data?.message || error?.message || error?.error?.message || "An unexpected error occurred"
            setResponse((prev: any) => ({
                ...prev,
                loading: false,
                message: errorMessage,
                status: status.ERROR
            }))
        })
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setShowModal(true)
    };

     const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
            const forbiddenChars = ['-', '+', 'e', 'E'];
            if (forbiddenChars.includes(event.key)) {
                event.preventDefault();
            }
        };

    return (
        <div>
            <div className='breadcrumb-section'>
                <AiOutlineHome />
                <span className="small"> &gt; <Link to="/settings" className="text-muted">Settings</Link> </span>
                <span className="small"> &gt; <span className="text-muted">GDPR Utility</span> </span>
                <span className="small"> &gt; <span className="text-muted">Process GDPR Request in Bulk</span> </span>
            </div>

            <div className='mt-3 d-flex flex-row align-items-start'>
                <Link to="/settings"><ArrowLeft /></Link>
                <div className='d-flex flex-column nav-padding'>
                    <h5>GDPR Utility</h5>
                    <p className="text-muted">You can perform GDPR for a group of candidates</p>
                </div>
            </div>

            <div className="text-spacing"><b>Note :</b>Kindly wait for some time after clicking the button. It may take couple of mins to get the data.</div>

            <Row>
                <Col xs={8}>
                    {error && <Alert variant="danger">{error}</Alert>}
                </Col>
                <Col></Col>
            </Row>

            <Form onSubmit={handleSubmit} ref={formRef}>
                {bulkGdprData?.map((data) => (
                    <Form.Group key={data.key} className='mb-4'>
                        <Row>
                            <Col>
                                <Form.Label>{data.fieldName}</Form.Label>
                            </Col>
                            <Col>
                                <div className="d-flex align-items-center position-relative">
                                    <Form.Control name={data.key} type={data.type} required={data.required} className={`form-max-width ${data.type === "file" ? "custom-width" : ""}`}
                                        accept={data.accept ? data.accept : undefined}
                                        onKeyPress={data.key === "clientId" ? handleKeyPress : undefined}
                                    />
                                    {data.tooltip && <OverlayTrigger placement="top" overlay={
                                        <Tooltip id="tooltip">
                                            Accepted format is only excel.
                                        </Tooltip>}>
                                        <Info className="position-absolute info-img" />
                                    </OverlayTrigger>}
                                </div>
                                {data.helperText && <Form.Text className="text-muted">{data.helperText}</Form.Text>}        
                            </Col>
                            <Col></Col>
                        </Row>
                    </Form.Group>
                ))}

                <Row>
                    <Col></Col>
                    <Col>
                        <Button type="submit" variant="danger" className="button-margin">Delete GDPR Request</Button>
                    </Col>
                    <Col></Col>
                </Row>

            </Form>

            {
                response.loading &&
                    <div className="text-center mt-5 pt-5">
                        <img src={loaderGif} alt="loading" height="150px" width="150px" />
                    </div>
            }

            {!response.loading && response.message && (
                <div className="d-flex align-items-center mt-3">
                    <img
                        src={response.status === status.SUCCESS ? "/success.svg" : "/error.svg"}
                        alt={response.status === status.SUCCESS ? "Success" : "Error"}
                        className="message-spacing"
                    />
                    <p className={`m-0 text-${response.status === status.SUCCESS ? "success" : "danger"}`}>
                        {response.message}
                    </p>
                </div>
            )}

            <Modal show={showModal} onHide={() => void 0} animation={false}>
                <Modal.Body>
                    Do you really want to submit this form?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowModal(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleSubmitConfirm}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ProcessBulkGDPR